import { DataTable } from "@msuite/ui/table";
import {
	VendorArticlesMenu,
	vendorArticlesColumns,
} from "@/components/stock/vendor-articles-table";
import { useVendorArticlesList } from "@/hooks/use-vendor-articles-list";
import type { ArticlePanelBaseProps } from "../shared";

export function ArticleVendors({ articleId }: ArticlePanelBaseProps) {
	/** Hooks */
	const { vendorArticles, isLoading, refetch, queryKey } = useVendorArticlesList(articleId);

	/** Render */
	return (
		<DataTable
			data={vendorArticles}
			columns={vendorArticlesColumns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<VendorArticlesMenu articleId={articleId} />}
			persistenceKey="vendor-articles-table"
		/>
	);
}
